import React from "react";
import { useTranslation } from "react-i18next";

export default function LanguageSwitcher({ variant = "pill" }) {
  const { i18n } = useTranslation();
  const isAr = i18n.language?.startsWith("ar");

  const toggle = () => {
    const next = isAr ? "en" : "ar";
    i18n.changeLanguage(next);
    localStorage.setItem("cabil_lang", next);
    document.documentElement.dir = next === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = next;
  };

  if (variant === "compact") {
    return (
      <button onClick={toggle} title={isAr ? "Switch to English" : "التبديل للعربية"}
        className="flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-lg border border-gray-200 hover:border-[#EE5F2B] hover:bg-orange-50 transition cursor-pointer bg-white text-gray-600">
        🌐 {isAr ? "EN" : "ع"}
      </button>
    );
  }

  return (
    <button onClick={toggle} title={isAr ? "Switch to English" : "التبديل للعربية"}
      style={{
        display: "inline-flex", alignItems: "center", gap: 4,
        background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8,
        padding: "4px 10px", cursor: "pointer", fontSize: 12, fontWeight: 600,
        color: "#555",
      }}>
      🌐 {isAr ? "English" : "العربية"}
    </button>
  );
}
